import { render, staticRenderFns } from "./detailed_form.vue?vue&type=template&id=44582ff9&scoped=true&"
import script from "./detailed_form.vue?vue&type=script&lang=js&"
export * from "./detailed_form.vue?vue&type=script&lang=js&"
import style0 from "./detailed_form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./detailed_form.vue?vue&type=style&index=1&id=44582ff9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44582ff9",
  null
  
)

export default component.exports